import { CSSProperties, ReactElement } from "react";
import { Row } from "@tanstack/react-table";
import { TableCell } from "./TableCell";

interface TableRowProps<TData> {
  row: Row<TData>;
  onRowClick?: (row: TData) => void;
  getRowClassName?: (data: TData) => string;
  getRowStyle?: (data: TData) => CSSProperties;
  /** Wraps the rendered <tr> (e.g. with a right-click menu) */
  rowWrapper?: (data: TData, tr: ReactElement) => ReactElement;
}

export function TableRow<TData>({ row, onRowClick, getRowClassName, getRowStyle, rowWrapper }: TableRowProps<TData>) {
  const customClassName = getRowClassName?.(row.original) || '';
  const baseClassName = "border-b transition-colors hover:bg-muted/50";
  const className = customClassName ? `${baseClassName} ${customClassName}` : baseClassName;
  const style = getRowStyle?.(row.original);

  const tr = (
    <tr
      data-state={row.getIsSelected() && "selected"}
      className={className}
      style={style}
      onClick={() => onRowClick?.(row.original)}
    >
      {row.getVisibleCells().map((cell) => (
        <TableCell key={cell.id} cell={cell} />
      ))}
    </tr>
  );

  return rowWrapper ? rowWrapper(row.original, tr) : tr;
}
